<template>
    <g
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
    >
        <circle
            cx="8"
            cy="8"
            r="6.667"
        /><path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M8 5.333v2.667l1.667 1.667"
        />
    </g>
</template>
